
import React,{useState,useRef,memo,useCallback,useEffect, Fragment} from 'react'
import {getContentPath} from  'system/AssetManager'
import {animateParallax,getAnimationModel,animateIntersect,setInitialAnimIntersectState,setFinalAnimIntersectState} from './CanvasAnimator'
import Globals from 'system/Globals'
// import {onErrorLoad} from 'system/AssetManager'
import gsap, {Power3} from 'gsap'
import { animEventEmitter } from "system/utils/eventEmitter"; 

function POPComponent(props){

    const [inline,setInline] = useState({})
    const [infoInline, setInfoInline] = useState({});
    const [arInline,setArInline] = useState({})
    const [imgSrc,setImgSrc] = useState(null)
    const [pngOpacity, setPngOpacity] = useState(1)
    const [isOn, setIsOn] = useState(false);
     
    let bLoaded=false
    const loadingAnim = useRef();
    const refPopup = useRef();
    const refEle = useRef()
    const refArEle = useRef()
    const refArInnerEle = useRef();
    const refFormat = useRef()
    const refOrigOffset = useRef(0)
    const refAnimationModel = useRef({})
    const refRunAnim = useRef(false);
    
    const arrowDown =  { width: 0, height: 0, borderLeft: "20px solid transparent", borderRight: "20px solid transparent", borderTop: "20px solid #fff", position: "absolute", marginLeft: "124px", marginTop: "20px"}

    const arrowUp =  { width: 0, height: 0, borderLeft: "20px solid transparent", borderRight: "20px solid transparent", borderBottom: "20px solid #fff", position: "absolute", marginLeft: "124px", marginTop: "-44px"}

    useEffect(()=>{ 
        if (refEle.current) {
            refOrigOffset.current=refEle.current.offsetLeft
        }
        
        if(refFormat.current && refFormat.current.animation && refFormat.current.animation.typeName){
            
            refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation) 
       

            if(props.renderOnly===true){
                setFinalAnimIntersectState(refEle.current,refFormat.current.animation)
            }
        }
        
    },[inline]) // eslint-disable-line react-hooks/exhaustive-deps
    
    const onScroll = useCallback((scrollLeft,scale,pageWidth)=>{
        // console.log(refAnimationModel.current)
        animateParallax(refEle.current,refAnimationModel.current,scrollLeft,pageWidth)
    },[props.model.animation,refEle])// eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        // console.log('props.pageState', props.pageState)
        
        if (props.pageState === "animPage" && inline && refAnimationModel.current && refAnimationModel.current.animations) {
            console.log('props.pageState', props.pageState)

            animateIntersect(refEle.current,refAnimationModel.current)

        
        }
    }, [props, inline])


    const onIntersect = useCallback((evt,threshold)=>{
        // console.log('PNG onINTERSECT', evt, evt.detail.isIntersecting)
        if(evt.detail.isIntersecting )
        {
            if(evt.detail.intersectionRatio >=threshold)
         
                animateIntersect(refEle.current,refAnimationModel.current)
              

        }
        else if(evt.detail.intersectionRatio <=0.001)
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
    },[refEle])

    const onAnim = useCallback((evt,threshold)=>{
        // console.log('PNG onAnim', evt)
        if(evt)
        {
            animateIntersect(refEle.current,refAnimationModel.current)

        }
        else {
            setInitialAnimIntersectState(refEle.current,refAnimationModel.current)
        }
            
    },[refEle])


    

    useEffect(()=>{

        refFormat.current = Globals.instance().getCanvasFormat(props.model.formats,props.format)
        let imgStyle ={position:'relative',transform: 'translateZ(0), perspective: 1000px', opacity: 0,  'width': '100%', 'height': '100%' , cursor: "pointer"};
        let arStyle = {position:'absolute',transform: 'translateZ(0), perspective: 1000px', opacity: 0};
        let infoStyle = {position:'absolute',transform: 'translateZ(0), perspective: 1000px', opacity: 0, width: "280px", height: "auto", textAlign: "left", background: 'white', borderRadius: "4px", padding: '24px', color: "black", boxShadow: "0 2px 10px rgba(0,0,0,0.3)", fontSize: '18px'}
        if (refFormat.current) {
            let resStyle;
            if(refFormat.current.style && !props.pageBkg){ 
                let left = refFormat.current.style.left;
                let top =  refFormat.current.style.top;
                let opacity = refFormat.current.style.opacity;
                let imgOpacity = refFormat.current.style.opacity;
                let transform = refFormat.current.style.transform;
                let height = 44;
                imgStyle = Object.assign(imgStyle,{'opacity': imgOpacity})
                setPngOpacity(imgOpacity)
                arStyle = Object.assign(arStyle,{'left': left, 'top': top, 'opacity': opacity, 'transform': transform})
                infoStyle = Object.assign(infoStyle,{'left': left, 'top': top, 'transform': transform})
            } else {
                imgStyle = Object.assign(imgStyle,{'opacity': 1})
                arStyle = Object.assign(imgStyle,{'opacity': 1})
            }

      
            let f = refFormat.current.file?refFormat.current.file:refFormat.current.image
            setImgSrc(getContentPath(f))
            
            if(refFormat.current.animation){

                if(refFormat.current.animation.typeName==='parallax'){
                    props.setScrollCallback(onScroll,props.index)
                    imgStyle.willChange='transform'
                } 
                else if(refFormat.current.animation.typeName==='page'){
                    props.onIntersect(onIntersect, props.index)
                    props.onAnim(onAnim, props.index)
                    imgStyle.willChange='transform, scale, opacity'
                }
            }
           
        }
        setInline(imgStyle)
        setArInline(arStyle);
        setInfoInline(infoStyle);

       
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    useEffect(() => {
        let onServerEvent;
        if (arInline && inline && refPopup.current) {

            setTimeout(() => {
                let btnWidth = refEle.current.offsetWidth;
                let btnHeight = refEle.current.offsetHeight;

                const { height, width } = refPopup.current.getBoundingClientRect();
                console.log('popup dims', height, width);
                const transform =
                    refFormat.current.popup_pos === "Above"
                        ? `translate(-${width / 2 - ((btnWidth-6)/2)}px,-${height+(btnHeight/2)+7}px)`
                        : `translate(-${width / 2 -  ((btnWidth-6)/2)}px,${btnHeight+32}px)`;
                    setInfoInline(prevInline => ({
                        ...prevInline,
                    transform,
                }));
            }, 300);

             // Listener
          onServerEvent=(evt)=>{
            let detail = evt.detail
            console.log('onServerEvent popup', detail)
            if(!detail)return
            if(detail.event==='narrative-popup'){
                if(parseInt(detail.command)===refFormat.current.id){
                    onPopUp();
                } else {
                    setIsOn(false)
                }
            } 
           
        }
        window.removeEventListener('server-event',onServerEvent)
        window.addEventListener('server-event',onServerEvent)
        
           
        } else {
            
        }
          return ()=>{
            window.removeEventListener('server-event',onServerEvent)
            // animEventEmitter.off("valueChanged", handleValueChange);
        }
    }, [arInline, inline])


    // useEffect(() => {
    //     if (imgSrc) {
    //         if (refEle.current && !bLoaded) {
    //             refEle.current.src = `${refEle.current.src}?t=${Date.now()}`;
    //             }
    //     }
    // }, [imgSrc])

    function onError(evt){
        console.error("PNG load error"+bLoaded, evt.target.src)
        // onErrorLoad(evt)
        // console.log("src "+evt.target.src)

        const img = refEle.current;
        let retryCount = 0;
        const maxRetries = 3;
        if (retryCount < maxRetries) {
            retryCount++;
            console.log(`Retrying image load (attempt ${retryCount})...`);
            setTimeout(() => {
              img.src = img.src; // Reload the image
            }, 1000); // Wait 1 second before retrying
          } else {
            console.error('Failed to load image after multiple retries.');
            // Optionally, display a placeholder image or error message
          }


        if(!bLoaded && imgSrc!==""){
            Globals.instance().trackError('PNG Component '+imgSrc+' ',false)

          

              
            onLoad() //dont hold up the page 
        }
    }
    
    function onLoad(){
        // console.log('onLoad', bLoaded, refFormat.current)
        // loadingAnim.current.pause();
        //down res the image
        if(!bLoaded){

            console.log('PNG loaded', refFormat.current.id)

            // gsap.to(refArEle.current, {
            //     backgroundColor: 'transparent',
            //     duration: 0.2,
            //     ease: "power1.inOut"
            // });
            // let opacity = refFormat.current.style.opacity;
            // gsap.to(refEle.current, {opacity: pngOpacity, duration: 0.2, delay: 1});
            gsap.to(refArInnerEle.current, {opacity: 1, duration: 0.2})

     

            

            props.onLoad(props.index,refEle.current,props.model)
            bLoaded=true

            if(props.renderOnly===true){
                refAnimationModel.current = getAnimationModel(refEle.current,refFormat.current.animation) 
                setFinalAnimIntersectState(refEle.current,refAnimationModel.current)
            }

         

        }
        
    }

    function onPopUp() {
        // console.log('onPopUp', refFormat.current)
        setIsOn(prev => !prev);
    }

    useEffect(() => {
        if (isOn) {
            gsap.to(refPopup.current, {opacity: 1, zIndex: 3, duration: 0.3})
        } else {
            gsap.to(refPopup.current, {opacity: 0, zIndex: -1, duration: 0.3})
        }
    }, [isOn])

    return ( 
        <Fragment>
            {refFormat.current && refFormat.current.html_text && <span style={infoInline} ref={refPopup}>
             {refFormat.current.popup_pos === 'Below' && <div style={arrowUp}></div>}
                {refFormat.current.html_text}
                {refFormat.current.popup_pos === 'Above' && <div style={arrowDown}></div>}
               
                </span>}
             <span className="arBox info-btn" style={arInline} ref={refArEle} id={refFormat.current && "component_dim_file_arBox_" + refFormat.current.component} data-fileformat={refFormat.current && refFormat.current.file_format}>
                <span className="arBoxInner" ref={refArInnerEle}>
                    {(imgSrc && refFormat.current) ? <img src={imgSrc} id={refFormat.current && "component_dim_file_" + refFormat.current.component} alt="" onClick={() => onPopUp()} onLoad={onLoad} style={inline} ref={refEle} data-opacity={pngOpacity} className={'force3d canvasImg ui' + ((props.pageBkg)?" bkg":"")} onError={onError}></img> : <span />}
                </span>
            </span>    
        </Fragment>
       
        
            
    )

}

const POP = memo(POPComponent, (prev,next)=>{  return prev.imgSrc === next.imgSr })
export  {POP}
